import { Analytics, getAnalytics, isSupported, logEvent } from 'firebase/analytics'
import firebaseApp from './firebase-app'

let analyticsInstance: Analytics | undefined
let isSupportedBrowser = true

const getAnalyticsInstance = async () => {
  if (analyticsInstance) return analyticsInstance
  else if (!isSupportedBrowser) return

  try {
    isSupportedBrowser = await isSupported()
    if (isSupportedBrowser) {
      analyticsInstance = getAnalytics(firebaseApp)
      return analyticsInstance
    }
    return
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err)
  }
}

const logAnalyticsEvent = async (
  eventName: string,
  eventParams?:
    | {
        [key: string]: unknown
      }
    | undefined
) => {
  const analytics = await getAnalyticsInstance()
  if (analytics) {
    logEvent(analytics, eventName, eventParams)
  }
}

export default logAnalyticsEvent
